import React, {useState} from 'react'
import i18n from 'i18next'
import {useAzubiList} from '#hooks/store/useAzubiList'
import AzubiTable from '../../components/o/MeineAzubis/AzubiTable'
import ErrorModal from '#components/m/ErrorModal'
import PageHeader from '#components/m/PageHeader'
import Headline from '#components/a/Headline'
import AbteilungenHeader from '#components/m/MeineAzubis/AbteilungenHeader'
import Loading from '#components/a/Loading'
import {LinkWithArrow} from '#components/m/MeineOrganisation/LinkWithArrow'
import {routeKeys} from '#config/routeKeys'
import {usePermissions} from '#hooks/usePermissions'
import {useSelector} from 'react-redux'

export default function MeineAzubis() {
  const permissions = usePermissions()
  const {canFilterAzubisByMyAbteilungen} = permissions.meineAzubis
  const {allAzubis, isLoading} = useAzubiList()

  const [showNoAusbilderWithValidEmailModal, setShowNoAusbilderWithValidEmailModal] = useState(false)

  const renderErrorModal = () => (
    <ErrorModal
      headline={i18n.t('misc_generic_error')}
      text={i18n.t('meineazubis_noausbilderwithemail_error')}
      showModal={showNoAusbilderWithValidEmailModal}
      buttonText={i18n.t('okay')}
      onButtonClick={() => setShowNoAusbilderWithValidEmailModal(false)}
    />
  )

  const meineAusbilderLinkVisibleModifier = permissions.meineAusbilder.manage
    ? ' meineazubis--meineAusbilderLinkVisible'
    : ''

  const meineAbteilungenVisibleModifer = canFilterAzubisByMyAbteilungen ? ' meineazubis--meineAbteilungenVisible' : ''

  const {filterMyAbteilung} = useSelector(state => state.filter)

  return (
    <section className={`meineazubis${meineAusbilderLinkVisibleModifier}${meineAbteilungenVisibleModifer}`}>
      <div className="meineazubis--header">
        <PageHeader
          headline={
            <div>
              <Headline importance={1} modifier="section" text={i18n.t('meineazubis_page_title')} />
              {permissions.meineAusbilder.manage && (
                <LinkWithArrow to={routeKeys.meineausbilder} text={i18n.t('meine_organisation_to_ausbildern')} />
              )}
            </div>
          }
        />
      </div>

      {permissions.meineAbteilungen.manage && <AbteilungenHeader />}

      <AzubiTable
        setShowNoAusbilderWithValidEmailModal={setShowNoAusbilderWithValidEmailModal}
        azubis={allAzubis}
        sendMailToAusbilder={permissions.meineAzubis.sendMailToAusbilder}
        withFilter
        hasFilterForAbteilungen={canFilterAzubisByMyAbteilungen && filterMyAbteilung}
      />

      <div className="loading_wrapper">{isLoading && <Loading />}</div>

      {renderErrorModal()}
    </section>
  )
}
